"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var pako_1 = require("pako");

var lerc_1 = __importDefault(require("lerc"));

var basedecoder_js_1 = __importDefault(require("./basedecoder.js"));

var globals_js_1 = require("../globals.js");

var LercDecoder = /*#__PURE__*/function (_basedecoder_js_1$def) {
  (0, _inherits2.default)(LercDecoder, _basedecoder_js_1$def);

  var _super = _createSuper(LercDecoder);

  function LercDecoder(fileDirectory) {
    var _this;

    (0, _classCallCheck2.default)(this, LercDecoder);
    _this = _super.call(this);
    _this.planarConfiguration = typeof fileDirectory.PlanarConfiguration !== 'undefined' ? fileDirectory.PlanarConfiguration : 1;
    _this.samplesPerPixel = typeof fileDirectory.SamplesPerPixel !== 'undefined' ? fileDirectory.SamplesPerPixel : 1;
    _this.addCompression = fileDirectory.LercParameters[globals_js_1.LercParameters.AddCompression];
    return _this;
  }

  (0, _createClass2.default)(LercDecoder, [{
    key: "decodeBlock",
    value: function decodeBlock(buffer) {
      switch (this.addCompression) {
        case globals_js_1.LercAddCompression.None:
          break;

        case globals_js_1.LercAddCompression.Deflate:
          buffer = (0, pako_1.inflate)(new Uint8Array(buffer)).buffer; // eslint-disable-line no-param-reassign, prefer-destructuring

          break;

        default:
          throw new Error("Unsupported LERC additional compression method identifier: ".concat(this.addCompression));
      }

      var lercResult = lerc_1.default.decode(buffer, {
        returnPixelInterleavedDims: this.planarConfiguration === 1
      });
      var lercData = lercResult.pixels[0];
      return lercData.buffer;
    }
  }]);
  return LercDecoder;
}(basedecoder_js_1.default);

exports.default = LercDecoder;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUNBOztBQUNBOztJQUVxQkEsVzs7Ozs7RUFDbkIscUJBQVlDLGFBQVosRUFBeUI7SUFBQTs7SUFBQTtJQUN2QjtJQUVBLE1BQUtDLG1CQUFMLEdBQTJCLE9BQU9ELGFBQWEsQ0FBQ0UsbUJBQXJCLEtBQTZDLFdBQTdDLEdBQTJERixhQUFhLENBQUNFLG1CQUF6RSxHQUErRixDQUExSDtJQUNBLE1BQUtDLGVBQUwsR0FBdUIsT0FBT0gsYUFBYSxDQUFDSSxlQUFyQixLQUF5QyxXQUF6QyxHQUF1REosYUFBYSxDQUFDSSxlQUFyRSxHQUF1RixDQUE5RztJQUVBLE1BQUtDLGNBQUwsR0FBc0JMLGFBQWEsQ0FBQ00sY0FBZCxDQUE2QkMsNEJBQWVDLGNBQTVDLENBQXRCO0lBTnVCO0VBT3hCOzs7O1dBRUQscUJBQVlDLE1BQVosRUFBa0I7TUFDaEIsUUFBUSxLQUFLSixjQUFiO1FBQ0UsS0FBS0UsZ0NBQW1CRyxJQUF4QjtVQUNFOztRQUNGLEtBQUtILGdDQUFtQkksT0FBeEI7VUFDRUYsTUFBTSxHQUFHLG9CQUFRLElBQUlHLFVBQUosQ0FBZUgsTUFBZixDQUFSLEVBQWdDQSxNQUF6QyxDQURGLENBQ21EOztVQUNqRDs7UUFDRjtVQUNFLE1BQU0sSUFBSUksS0FBSixzRUFBd0UsS0FBS1IsY0FBN0UsRUFBTjtNQVBKOztNQVVBLElBQU1TLFVBQVUsR0FBR0MsZUFBS0MsTUFBTCxDQUFZUCxNQUFaLEVBQW9CO1FBQUVRLDBCQUEwQixFQUFFLEtBQUtoQixtQkFBTCxLQUE2QjtNQUEzRCxDQUFwQixDQUFuQjtNQUNBLElBQU1pQixRQUFRLEdBQUdKLFVBQVUsQ0FBQ0ssTUFBWCxDQUFrQixDQUFsQixDQUFqQjtNQUNBLE9BQU9ELFFBQVEsQ0FBQ1QsTUFBaEI7SUFDRDs7O0VBeEJzQ1csd0I7O0FBQXpDQyIsIm5hbWVzIjpbIkxlcmNEZWNvZGVyIiwiZmlsZURpcmVjdG9yeSIsInBsYW5hckNvbmZpZ3VyYXRpb24iLCJQbGFuYXJDb25maWd1cmF0aW9uIiwic2FtcGxlc1BlclBpeGVsIiwiU2FtcGxlc1BlclBpeGVsIiwiYWRkQ29tcHJlc3Npb24iLCJMZXJjUGFyYW1ldGVycyIsImdsb2JhbHNfanNfMSIsIkFkZENvbXByZXNzaW9uIiwiYnVmZmVyIiwiTm9uZSIsIkRlZmxhdGUiLCJVaW50OEFycmF5IiwiRXJyb3IiLCJsZXJjUmVzdWx0IiwibGVyY18xIiwiZGVjb2RlIiwicmV0dXJuUGl4ZWxJbnRlcmxlYXZlZERpbXMiLCJsZXJjRGF0YSIsInBpeGVscyIsImJhc2VkZWNvZGVyX2pzXzEiLCJleHBvcnRzIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2Rpc3QtbW9kdWxlL2NvbXByZXNzaW9uL2xlcmMuanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=